export default "__VITE_ASSET__1fb9ce7c__"